import { PageHeader } from "../common/PageHeader";
import MonitorEventList from "./MonitorEventList";
import { routes } from "../../appRoutingHelpers";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";

export const UserMonitorEventList = () => {
  const { id } = useParams<{
    id: string;
  }>();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  return (
    <div className="container">
      <PageHeader
        title="User Monitor Events"
        breadcrumbs={[
          { title: "Users" },
          { title: "Overview", link: routes.userList(organizationKeyName) },
          {
            title: "Profile",
            link: routes.userProfile(organizationKeyName, id),
          },
          { title: "Monitor Events", isActive: true },
        ]}
      />

      <div className="row row-cards row-deck">
        <div className="col-12">
          <MonitorEventList organization={organizationKeyName} userId={id} />
        </div>
      </div>
    </div>
  );
};
